export const transplantCenterSubSectionNavMixin = {
  computed: {
    subSectionNav() {
      if(!this.$route.params.id) return null;
      return [
        { to: { name: 'admin_transplant_centers_edit', params: { id: this.$route.params.id } }, label: 'TxC Configurations' },
      ]
    }
  }
}
